import { Api } from 'utils';

class ChatService {

	static admin = {
		get: async (params?: any) => Api.createResponse('admin/chat',params),
		save: async (params?: any) => Api.createResponse('admin/chat/save',params),
		getInformation: async (params?: any) => Api.createResponse('admin/chat/information',params),
		saveInformation: async (params?: any) => Api.createResponse('admin/chat/save-information',params),
		deleteInformation: async (params?: any) => Api.createResponse('admin/chat/delete-information',params),
	}

}

export default ChatService;